import { render, staticRenderFns } from "./Vector.vue?vue&type=template&id=b57ff22c&scoped=true"
import script from "./Vector.vue?vue&type=script&lang=js"
export * from "./Vector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57ff22c",
  null
  
)

export default component.exports